<div>
    <div>
        <div>
            <div>
                <h2 class="mb-4">{{ editingId ? 'Edit post' : 'Write a blog or poem' }}</h2>

                <div *ngIf="!allowed" class="alert alert-info">
                    Only members can write blog posts. You can still read, like and comment.
                    <a routerLink="/blogs">Back to blogs</a>
                </div>

                <form *ngIf="allowed" #blogForm="ngForm" (ngSubmit)="save()" class="col-lg-9 p-0">
                    <div class="form-group">
                        <label for="blog-title">Title</label>
                        <input id="blog-title" name="title" class="form-control" maxlength="150" required
                               [(ngModel)]="draft.title">
                    </div>

                    <div class="form-group">
                        <label for="blog-category">Type</label>
                        <select id="blog-category" name="category" class="form-control" [(ngModel)]="draft.category">
                            <option *ngFor="let c of categories" [value]="c.value">{{ c.label }}</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label>Cover image (optional, up to 5 MB)</label>
                        <input type="file" class="form-control-file" accept="image/png,image/jpeg,image/gif,image/webp"
                               (change)="onCoverPicked($event)">
                        <img *ngIf="coverPreview || existingCover" [src]="coverPreview || existingCover"
                             class="mt-2 blog-cover-preview" alt="Cover preview">
                    </div>

                    <div class="form-group">
                        <label>Body</label>
                        <app-rt-editor name="contentHtml" [(ngModel)]="draft.contentHtml"
                                       placeholder="Write your article, poem or story…"></app-rt-editor>
                    </div>

                    <button type="submit" class="btn btn-dark-primary mr-2" [disabled]="!canSave">
                        {{ editingId ? 'Save changes' : 'Publish' }}
                    </button>
                    <a class="rana-action-btn" [routerLink]="editingId ? ['/blogs', editingId] : ['/blogs']">Cancel</a>
                </form>
            </div>
        </div>
    </div>
</div>
